import React, { Component } from 'react';
import Editor from '@monaco-editor/react';
import { RootState } from '../../../../../redux/store';
import { changeApiVariable } from '../../../../../redux/actions/ApiVariableActions';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import RoleHelper from '../../../../../RoleHelper';
import ComponentName from '../../../../../constant/ComponentName';

class ApiBodyComponent extends Component<Props, State> {
  public state = new State();

  public render() {
    const { language } = this.state;
    const {
      apiVariable: { apiVariable },
    } = this.props;
    return (
      <div className={'w-full h-full flex relative mt-4'}>
        {
          <Editor
            options={{
              readOnly: !RoleHelper.canEdit('EnrichmentApi'),
            }}
            onMount={(editor) => {
              editor.updateOptions({ fontSize: 12, minimap: { enabled: false } });
            }}
            language={language}
            value={(apiVariable.body as string) || ''}
            onChange={(value) => this.onChangeEditorValue(value as string)}
            data-testid={`${ComponentName.API_VARIABLE}_body_editor`}
          />
        }
      </div>
    );
  }

  private onChangeEditorValue(value: string) {
    const {
      apiVariable: { apiVariable },
      changeApiVariable,
    } = this.props;
    if (!RoleHelper.canEdit('EnrichmentApi')) return;
    // TODO JSON XML PARSER
    apiVariable.body = value;
    changeApiVariable(apiVariable);
  }
}

interface Props extends ReduxProps {}

type EditorLanguage = 'json' | 'xml' | 'text';

class State {
  language: EditorLanguage = 'json';
  editor: string = '';
}

const mapStateToProps = (state: RootState) => ({
  apiVariable: state.apiVariable,
  isUpdate: state.apiVariable.isUpdate,
});

const mapDispatchToProps = { changeApiVariable };
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(ApiBodyComponent);
